"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GetInTouch() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="relative min-h-[60vh] flex items-center justify-center px-4 py-24 overflow-hidden bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1475502/img/subtle_texture_background.png')] bg-fixed bg-center bg-cover">
      {/* Overlay for contrast */}
      <div className="absolute inset-0 bg-background/70 backdrop-blur-sm" />

      {/* Content */}
      <div className={`relative z-10 max-w-3xl mx-auto text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        <h2 className="text-4xl md:text-5xl font-display font-bold text-foreground mb-6">
          Get in Touch
        </h2>
        <p className="text-lg md:text-xl text-muted mb-10 leading-relaxed">
          I work with a limited number of clients, primarily through referrals
          and existing relationships. I take on new work selectively, with an
          emphasis on strong fit. You're welcome to reach out if you think
          there may be alignment.
        </p>
        <Link to="/ContactPage">
          <Button size="lg" className="btn-primary shadow-medium hover:shadow-strong transform hover:scale-105 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
            Get in Touch
          </Button>
        </Link>
      </div>
    </section>;
}